import * as React from "react";
import { cn } from "./utils";

interface TextareaFieldsetProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  required?: boolean;
}

const TextareaFieldset = React.forwardRef<
  HTMLTextAreaElement,
  TextareaFieldsetProps
>(({ className, label, required, ...props }, ref) => (
  <fieldset
    className={cn(
      "w-full rounded-[0.6rem] border-0 bg-transparent px-3 pb-2 pt-1",
      "shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)] transition-all",
      "focus-within:shadow-[inset_0_0_0_1px_rgba(59,130,246,0.6),0_0_0_3px_rgba(59,130,246,0.25)]",
    )}
  >
    <legend className="mb-1 bg-white px-1">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      {required && <span className="ml-1 text-red-500">*</span>}
    </legend>
    <textarea
      ref={ref}
      className={cn(
        "min-h-16 w-full resize-y border-none bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground focus:ring-0",
        className,
      )}
      {...props}
    />
  </fieldset>
));

TextareaFieldset.displayName = "TextareaFieldset";

export { TextareaFieldset };
